import { Inject } from '@odinjs/odin';

import { catchRenderException, ReportService } from '@philips-emr/hpms-stipulator-commons';
import { HpmsReportListApi, Report } from '@philips-emr/hpms-stipulator-components';
import Controller, { OnClick, OnClose, OnMount } from '@philips-emr/tws-core/lib/client';
import { ClickEvent } from '@philips-emr/tws-core/lib/component/types';
import { SessionStorageService } from '@philips-emr/tws-core/lib/services';

import BaseController from './BaseController';

@Controller({ fragment: 'hpms-reports-modal', component: 'modal-reports' })
class HpmsReportsModalController extends BaseController {

  @Inject('hpms-report-list')
  private repList: HpmsReportListApi;

  private params = {};

  private reportService: ReportService;

  @OnMount('layout-modal')
  onMount(): void {
    const {
      relatorioParametros,
      cdGrupo,
      parametrosLista,
      endpointLista,
    } = SessionStorageService.getItem('dados_relatorios');

    this.params = relatorioParametros;
    this.reportService = new ReportService(cdGrupo, endpointLista);
    void this.reportService.getRelatoriosByCdGrupo(parametrosLista)
      .then((reps: Report[]) => {
        this.repList.setData(reps);
      });
  }

  @OnClose('layout-modal')
  onclose(): void {
    SessionStorageService.removeItem('dados_relatorios');
    this.historyService.back();
  }

  @OnClick('hpms-report-list')
  onRepClick(e: ClickEvent): void {
    this.repList.setLoading(true);

    const relat = e.value as Report;
    this.reportService.gerarRelatorio(relat.cdRelatorio, relat.cdClassifRelat, this.params)
      .then(() => this.repList.setLoading(false))
      .catch(() => catchRenderException(() =>this.repList.setLoading(false)));
  }

}
export default HpmsReportsModalController;
